import { combineReducers } from 'redux';
import dasboardReducer from './dashboardReducer';

const roootReducers = combineReducers({
  dasboardReducer,
});

export default roootReducers;
